export enum ChargerAvailabilityStatus {
  Inoperative,
  Operative
}
